import React, { ImgHTMLAttributes } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface ApplicationLogoProps extends ImgHTMLAttributes<HTMLImageElement> {}

const ApplicationLogo: React.FC<ApplicationLogoProps> = ({ ...props }) => {
    const { theme } = useTheme();

    const assetBaseUrl = import.meta.env.VITE_ASSET_BASE_URL;
    const logo = theme === 'dark' ? 'logoBlack.svg' : 'logoWhite.svg';

    if (!assetBaseUrl) {
         window.logger.error('VITE_ASSET_BASE_URL is not set');
    }

    return (
        <img
            {...props}
            src={`/assets/logo/${logo}`}
            alt="Application Logo"
        />
    );
};

export default ApplicationLogo;
